import { ChangeBusinessDetails } from './ChangeBusinessDetails';

export class ChangeHeadScripts extends ChangeBusinessDetails {
  type: string = 'ChangeHeadScripts';
}
